import React, { useEffect, useState, useCallback } from 'react';
import { TopNav } from '../components/TopNav';
import { PerformanceComparator } from '../components/PerformanceComparator';
import { listPartnerships, createPartnership, deletePartnership, type PartnershipDto } from '@/services/partnerships';

interface PageProps { theme: string; toggleTheme: () => void }

const PartnershipsPage: React.FC<PageProps> = ({ theme, toggleTheme }) => {
  const [items, setItems] = useState<PartnershipDto[]>([]);
  const [brand, setBrand] = useState('');
  const [status, setStatus] = useState('em negociação');

  const handleAddPartnership = useCallback(async () => {
    if (!brand) return;
    try {
      await createPartnership({ brandName: brand, status, details: [{ label: 'Valor estimado', value: '—' }] });
      setBrand('');
      setItems(await listPartnerships());
    } catch (error) {
      console.error('Failed to create partnership:', error);
    }
  }, [brand, status]);

  const handleDeletePartnership = useCallback(async (id: string) => {
    try {
      await deletePartnership(id);
      setItems(await listPartnerships());
    } catch (error) {
      console.error('Failed to delete partnership:', error);
    }
  }, []);
  useEffect(() => {
    const loadPartnerships = async () => {
      try {
        setItems(await listPartnerships());
      } catch (error) {
        console.error('Failed to load partnerships:', error);
      }
    };
    loadPartnerships();
  }, []);
  return (
    <div className="min-h-screen bg-body">
      <TopNav theme={theme} toggleTheme={toggleTheme} />
      <main className="max-w-7xl mx-auto p-3 md:p-4">
        <h1 className="text-xl font-extrabold text-primary mb-3">Parcerias</h1>
        <p className="text-sm text-muted mb-2">Status e detalhes de marcas e artistas.</p>
        <div className="bg-white dark:bg-[#181818] border border-zinc-200 dark:border-zinc-800 rounded-lg p-3 mb-4 flex gap-2 items-end">
          <div className="flex-1">
            <label className="text-xs text-muted">Marca</label>
            <input className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={brand} onChange={e=>setBrand(e.target.value)} placeholder="ex.: Nike"/>
          </div>
          <div>
            <label className="text-xs text-muted">Status</label>
            <input className="w-44 px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={status} onChange={e=>setStatus(e.target.value)} />
          </div>
          <button className="px-3 py-2 rounded-md bg-zinc-900 text-white dark:bg-green-500 dark:text-black" onClick={handleAddPartnership}>Adicionar</button>
        </div>
        <PerformanceComparator partnerships={items} />
        {items.length>0 && (
          <div className="mt-3 text-sm bg-white/70 dark:bg-black/30 rounded-lg border border-default p-3">
            <p className="font-semibold mb-2">Parcerias (admin)</p>
            <ul className="space-y-1">
              {items.map(p => (
                <li key={p.id} className="flex items-center justify-between">
                  <span className="text-muted truncate mr-2">{p.brandName} — {p.status}</span>
                  <button className="text-red-500 text-xs" onClick={() => handleDeletePartnership(p.id)}>excluir</button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </main>
    </div>
  );
};

export default PartnershipsPage;
